import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {DonateComponent} from "./components/DonateComponent";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Flow} from "../../../flows/Flow.js";
import {styleRule} from "../../../../../stem-core/src/decorators/Style.js";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme.js";


export class DonatePanelStyle extends BasePanelPageStyle {
    @styleRule
    button = {
        width: "100%",
        marginTop: 18,
    }
}

@registerStyle(DonatePanelStyle)
export class DonatePanel extends BasePanelPage {
    render() {
        return [
            <DonateComponent ref="donateComponent" onChange={() => this.redraw()}/>,
            <MerchantButton
                label={Flow.donationDetails.getDonateComponentButtonLabel()}
                disabled={!Flow.donationDetails.isValid()}
                onClick={() => this.donate()}
                className={this.styleSheet.button}/>,
        ];
    }

    donate() {
        Flow.paymentMethod.showPanel();
    }

    onMount() {
        super.onMount();

        this.redraw(); // This is for the first rendering where the button doesn't have a label.
    }
}
